import { render, staticRenderFns } from "./IncomeTotalBaseTableBodyRow.vue?vue&type=template&id=067bd17c&"
import script from "./IncomeTotalBaseTableBodyRow.vue?vue&type=script&lang=js&"
export * from "./IncomeTotalBaseTableBodyRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports